import {touchInputsInError} from 'app/js/ui.utils';
import {IWizardStepManager} from './wizardStepManager.ctrl';

export interface IWizardStep {
    displayOrder: number;
    isValidated: boolean;
    setValidate(validated: boolean): void;
    validate(updateUiFields: boolean): string;
    show(show: boolean): void;
    getPrevText(): void;
    getNextText(): void;
    getConfirmText(): void;
    validateAndUpdateMessage(touchErrorUiFields: boolean): void;
}
export class WizardStepController<TManager extends IWizardStepManager> implements ng.IComponentController, IWizardStep {
    // public static $inject = ['$scope', '$element', '$attrs'];
    public name= '';
    public wizardManager: TManager;
    public isShown: boolean;
    public displayOrder: number; // >=0
    public isValidated = false;
    public mainForm: ng.IFormController;

    constructor(public $scope: ng.IScope, private $element: JQuery, $attrs: ng.IAttributes,
                private getMainForm: () => ng.IFormController = null as any ) {
    }

    public $onInit() {
        if (typeof(this.displayOrder) === 'undefined' || this.displayOrder < 0) {
            throw new Error('displayOrder is required.');
        }
        this.wizardManager.registerStep(this);
        this.registered();
    }

    public $postLink() {
        if (this.getMainForm) {
            this.mainForm = this.getMainForm();
        }
    }

    public setValidate(validated: boolean) {
        this.isValidated = validated;
    }

    public validate(updateUiFields: boolean): string {
        let errorMessage = '';
        if (this.mainForm) {
            if (updateUiFields) {
                touchInputsInError(this.mainForm);
            }
            errorMessage += this.getCommonFormError();
        }

        errorMessage += this.validateBoundData();

        this.setValidate(!errorMessage);
        return errorMessage;
    }

    public validateAndUpdateMessage(updateUiFields: boolean) {
        // it only validates when it is active.
        if (this.wizardManager && this.wizardManager.isActiveStep(this)) {
            this.wizardManager.validateStep(this, updateUiFields);
        }
    }

    public validateBoundData(): string {
        throw new Error('Method not implemented.');
    }

    public show(show: boolean) {
        const ngHide = 'ng-hide';
        this.isShown = show;
        if (this.isShown) {
            this.$element.removeClass(ngHide);
        } else {
            if (!this.$element.hasClass(ngHide)) {
                this.$element.addClass(ngHide);
            }
        }
    }

    public getPrevText() {
        return '';
    }

    public getNextText() {
        return '';
    }

    public getConfirmText() {
        return '';
    }

    protected registered() {
    }

    private getCommonFormError() {
        let errorMessage = '';
        if (this.mainForm) {
            angular.forEach(this.mainForm.$error.required, (inputCtrl) => {
                if (inputCtrl.$name) {
                    errorMessage += `'${inputCtrl.$name}' is required.\r\n`;
                }
            });
            angular.forEach(this.mainForm.$error.number, (inputCtrl) => {
                if (inputCtrl.$name) {
                    errorMessage += `'${inputCtrl.$name}' should be a valid number.\r\n`;
                }
            });
        }
        return errorMessage;
    }
}

// angular.module('tf.portfolio.ticket').component('orderWizardStep', {
//     controller : OrderWizardStepComponentController as any,
//     templateUrl : 'app/portfolio/templates/ticket/placingOrderWizard/orderWizardStep.tpl.html',
//     require: {
//       wizardManager: '^placingOrderWiardManager',
//     },
//     bindings : {
//         isShown: '<',
//     },
// });
